//Copyright © 2021 Cloudcontainers b.v. - All Rights Reserved

export default {
	RESPONSETIMEOUT: 0
};
